import { SectionTitle } from '../components/SectionTitle';
import { components } from '@mosey/api-types';
import { useLoaderData } from 'react-router-dom';
import { SignaturesDonut } from '../components/SignaturesDonut';

export const OverviewSignaturesSection = () => {
  const { acknowledgements } =
    useLoaderData() as components['schemas']['HandbookStats'];

  return (
    <div className="flex min-w-[350px] flex-col gap-4">
      <SectionTitle title="Signatures" to="/handbook/signatures" />
      <SignaturesDonut
        signed={acknowledgements.signed}
        outdated={acknowledgements.outdated}
        pending={acknowledgements.pending}
      />
    </div>
  );
};
